import { Component, OnInit, Output, EventEmitter,Input  } from '@angular/core';
import { ImageCroppedEvent } from 'ngx-image-cropper';

@Component({
  selector: 'app-crop',
  templateUrl: './crop.component.html',
  styleUrls: ['./crop.component.css']
})
export class CropComponent {
  title = 'angular-image-uploader';
  ngOnInit(): void {
 
  }



    //@Input() is_login: boolean;
    @Output() imgback: EventEmitter<boolean> = new EventEmitter();
    imageChangedEvent: any = '';
    croppedImage: any = '';

    fileChangeEvent(event: any): void {
        this.imageChangedEvent = event;
    }
    imageCropped(event: ImageCroppedEvent) {
        this.croppedImage = event.base64;
        
    }

    confirm(){
      this.imgback.emit(this.croppedImage);
    }

    imageLoaded() {
        // show cropper
        console.log(2);
    }
    cropperReady() {
        // cropper ready
        console.log(3);
    }
    loadImageFailed() {
        // show message
        // console.log(4);
    }
}